module.exports = __webpack_public_path__ + "8a6eccb319afdb0c8261123c4009ce60.png";